import React from 'react'
import styled from 'styled-components'

import InboxContact from './contacts/InboxContact'
import { Inbox } from '../../../../common/types/common.type'

interface IProps {
  activeNumber: string
  setCurrentChat: (chat: Inbox) => void
  sideBarData: Inbox[]
}
function Sidebar(props: IProps) {
  const { activeNumber, setCurrentChat, sideBarData } = props
  const [data, setData] = React.useState(sideBarData || [])
  const [activeChat, setActiveChat] = React.useState({})
  const [active, setActive] = React.useState()
  const handleChangeChat = (chat: Inbox) => {
    setCurrentChat(chat)
    setActiveChat(chat)
  }
  React.useEffect(() => {
    setData(sideBarData)
  }, [sideBarData])

  return (
    <div
      style={{
        minWidth: '300px',
        flex: '5%',
        borderRight: '1px solid #dadada',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
      }}
    >
      <Header style={{ background: 'rgb(237,237,237)' }}>
        <div style={{ fontWeight: '600' }}>Pixel Whatsapp</div>
      </Header>
      {/* <SearchField /> */}
      <ContactContainer style={{ borderTop: '1px solid #dadada' }}>
        {' '}
        {data.map((inbox) => (
          <InboxContact
            key={inbox.customer_number}
            inbox={inbox}
            active={active}
            setActive={setActive}
            isActive={activeChat}
            onChangeChat={handleChangeChat}
            activeNumber={activeNumber}
          />
        ))}
      </ContactContainer>
    </div>
  )
}
export default Sidebar

const Header = styled.div`
  background: '#dddbd1';
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 10px;
  min-height: 60px;
`

const ContactContainer = styled.div`
  flex: 1;
  overflow-y: scroll;
  background: 'white';
  border-top: 1px solid '#dadada';
  max-height: 100%;
  height: 100%;
  overflow: auto;
`
